import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Templates = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0.5C6.17157 0.5 5.5 1.17157 5.5 2V2.5H5C4.17157 2.5 3.5 3.17157 3.5 4V4.5H3C2.17157 4.5 1.5 5.17157 1.5 6V14C1.5 14.8284 2.17157 15.5 3 15.5H9C9.82843 15.5 10.5 14.8284 10.5 14V13.5H11C11.8284 13.5 12.5 12.8284 12.5 12V11.5H13C13.8284 11.5 14.5 10.8284 14.5 10V2C14.5 1.17157 13.8284 0.5 13 0.5H7ZM9.5 13.5H5C4.17157 13.5 3.5 12.8284 3.5 12V5.5H3C2.72386 5.5 2.5 5.72386 2.5 6V14C2.5 14.2761 2.72386 14.5 3 14.5H9C9.27614 14.5 9.5 14.2761 9.5 14V13.5ZM5 3.5H5.5V10C5.5 10.8284 6.17157 11.5 7 11.5H11.5V12C11.5 12.2761 11.2761 12.5 11 12.5H5C4.72386 12.5 4.5 12.2761 4.5 12V4C4.5 3.72386 4.72386 3.5 5 3.5ZM6.5 2C6.5 1.72386 6.72386 1.5 7 1.5H13C13.2761 1.5 13.5 1.72386 13.5 2V10C13.5 10.2761 13.2761 10.5 13 10.5H7C6.72386 10.5 6.5 10.2761 6.5 10V2ZM8 3.5C7.72386 3.5 7.5 3.72386 7.5 4C7.5 4.27614 7.72386 4.5 8 4.5H12C12.2761 4.5 12.5 4.27614 12.5 4C12.5 3.72386 12.2761 3.5 12 3.5H8ZM8 5.5C7.72386 5.5 7.5 5.72386 7.5 6C7.5 6.27614 7.72386 6.5 8 6.5H12C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5H8ZM7.5 8C7.5 7.72386 7.72386 7.5 8 7.5H10C10.2761 7.5 10.5 7.72386 10.5 8C10.5 8.27614 10.2761 8.5 10 8.5H8C7.72386 8.5 7.5 8.27614 7.5 8Z"
      />
    </svg>
  )
})

export default Templates
